import React from 'react';
import { Badge } from '@chakra-ui/react';

interface Props {
  originalFileTeam?: string | null;
}

/**
 * Badge grigio "IMP" per sessioni cross-team importate (M6.2 B10).
 * Title HTML nativo mostra team originale da file.
 */
export function ImportBadge({ originalFileTeam }: Props) {
  const label = originalFileTeam
    ? `Importato da file di: ${originalFileTeam}`
    : 'Importato cross-team';
  return (
    <Badge
      colorPalette="gray"
      variant="subtle"
      fontSize="xs"
      title={label}
      cursor="help"
    >
      IMP
    </Badge>
  );
}
